var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isView,
          expression: "isView",
        },
      ],
      staticClass: "flow-containers",
      class: { "view-mode": _vm.isView },
    },
    [
      _c(
        "el-container",
        { staticStyle: { height: "100%" } },
        [
          _c(
            "el-header",
            {
              staticStyle: {
                "border-bottom": "1px solid rgb(218 218 218)",
                height: "auto",
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    padding: "10px 0px",
                    "justify-content": "space-between",
                  },
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "el-upload",
                        {
                          staticStyle: {
                            "margin-right": "10px",
                            display: "inline-block",
                          },
                          attrs: { action: "", "before-upload": _vm.openBpmn },
                        },
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: "加载xml",
                                placement: "bottom",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  size: "mini",
                                  icon: "el-icon-folder-opened",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            content: "新建",
                            placement: "bottom",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              size: "mini",
                              icon: "el-icon-circle-plus",
                            },
                            on: { click: _vm.newDiagram },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            content: "自适应屏幕",
                            placement: "bottom",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: { size: "mini", icon: "el-icon-rank" },
                            on: { click: _vm.fitViewport },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            content: "放大",
                            placement: "bottom",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: { size: "mini", icon: "el-icon-zoom-in" },
                            on: {
                              click: function ($event) {
                                return _vm.zoomViewport(true)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            content: "缩小",
                            placement: "bottom",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: { size: "mini", icon: "el-icon-zoom-out" },
                            on: {
                              click: function ($event) {
                                return _vm.zoomViewport(false)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            content: "后退",
                            placement: "bottom",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: { size: "mini", icon: "el-icon-back" },
                            on: {
                              click: function ($event) {
                                _vm.modeler.get("commandStack").undo()
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            content: "前进",
                            placement: "bottom",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: { size: "mini", icon: "el-icon-right" },
                            on: {
                              click: function ($event) {
                                _vm.modeler.get("commandStack").redo()
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", icon: "el-icon-download" },
                          on: {
                            click: function ($event) {
                              return _vm.saveXML(true)
                            },
                          },
                        },
                        [_vm._v("下载xml")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", icon: "el-icon-picture" },
                          on: {
                            click: function ($event) {
                              return _vm.saveImg("svg", true)
                            },
                          },
                        },
                        [_vm._v("下载svg")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.save },
                        },
                        [_vm._v("保存模型")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-container",
            { staticStyle: { "align-items": "stretch" } },
            [
              _c("el-main", { staticStyle: { padding: "0" } }, [
                _c("div", { ref: "canvas", staticClass: "canvas" }),
              ]),
              _vm._v(" "),
              _c(
                "el-aside",
                {
                  staticStyle: {
                    width: "400px",
                    "min-height": "650px",
                    "background-color": "#f0f2f5",
                  },
                },
                [
                  _vm.modeler
                    ? _c("panel", {
                        attrs: {
                          modeler: _vm.modeler,
                          users: _vm.users,
                          groups: _vm.groups,
                          categorys: _vm.categorys,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }